// Arquivo gerado automaticamente a partir de bancos.csv
export const BANCOS_BRASIL = [
  "99PAY IP S.A.",
  "A55 SCD S.A.",
  "ACCREDITO SCD S.A.",
  "ACESSO SOLUÇÕES DE PAGAMENTO S.A. - INSTITUIÇÃO DE PAGAMENTO",
  "Advanced Cc Ltda",
  "ALL IN CRED SCD S.A.",
  "ARTTA SCD",
  "ASA SCFI S.A.",
  "ASAAS IP S.A.",
  "ATICCA SCD S.A.",
  "B&T Cc Ltda",
  "BANCO A.J.RENNER S.A.",
  "BANCO BARI S.A.",
  "BANCO BTG PACTUAL S.A.",
  "BANCO DIGIO",
  "BANCO GENIAL",
  "BANCO INBURSA",
  "BANCO INTER",
  "BANCO LETSBANK S.A.",
  "BANCO MASTER",
  "BANCO ORIGINAL",
  "BANCO PAN",
  "BANCO RANDON S.A.",
  "BANCO SEMEAR",
  "BANCO SICOOB S.A.",
  "BANCO TOPÁZIO S.A.",
  "BANCO TRAVELEX S.A.",
  "Banco ABN AMRO S.A",
  "Banco Andbank (Brasil) S.A.",
  "Banco Bbi S.A",
  "Banco BOCOM BBM S.A.",
  "Banco Bradescard S.A.",
  "Banco Cargill S.A.",
  "Banco Carrefour",
  "Banco Finaxis S.A.",
  "Banco Inbursa S.A.",
  "Banco Itaú BBA S.A.",
  "Banco Itaú Consignado S.A.",
  "Banco KDB S.A.",
  "Banco Morgan Stanley S.A.",
  "Banco Nacional de Desenvolvimento Econ...",
  "Banco Original Do Agronegócio S.A",
  "Banco da China Brasil S.A.",
  "Banco de Desenvolvimento do Espírito Santo...",
  "BANCOSEGURO S.A.",
  "BCO ABC BRASIL S.A.",
  "BCO AFINZ S.A. - BM",
  "BCO AGIBANK S.A.",
  "BCO ALFA S.A.",
  "BCO ARBI S.A.",
  "BCO B3 S.A.",
  "BCO BANESTES S.A.",
  "BCO BMG S.A.",
  "BCO BNP PARIBAS BRASIL S A",
  "BCO BRADESCO S.A.",
  "BCO BRASILEIRO DE CRÉDITO S.A.",
  "BCO BS2 S.A.",
  "BCO BV S.A.",
  "BCO C6 S.A.",
  "BCO CETELEM S.A.",
  "BCO CITIBANK S.A.",
  "BCO COOPERATIVO SICREDI S.A.",
  "BCO CREFISA S.A.",
  "BCO CSF S.A.",
  "BCO DA AMAZONIA S.A.",
  "BCO DAYCOVAL S.A",
  "BCO DIGIMAIS S.A.",
  "BCO DO BRASIL S.A.",
  "BCO DO EST. DE SE S.A.",
  "BCO DO EST. DO PA S.A.",
  "BCO DO ESTADO DO RS S.A.",
  "BCO DO NORDESTE DO BRASIL S.A.",
  "BCO FIBRA S.A.",
  "BCO GUANABARA S.A.",
  "BCO HSBC S.A.",
  "BCO INDUSTRIAL DO BRASIL S.A.",
  "BCO J.P. MORGAN S.A.",
  "BCO KEB HANA DO BRASIL S.A.",
  "BCO LUSO BRASILEIRO S.A.",
  "BCO MERCANTIL DO BRASIL S.A.",
  "BCO MODAL S.A.",
  "BCO PAULISTA S.A.",
  "BCO PINE S.A.",
  "BCO RENDIMENTO S.A.",
  "BCO RIBEIRAO PRETO S.A.",
  "BCO SAFRA S.A.",
  "BCO SANTANDER (BRASIL) S.A.",
  "BCO SENFF S.A.",
  "BCO SOFISA S.A.",
  "BCO TRIANGULO S.A.",
  "BCO VOTORANTIM S.A.",
  "BCO VR S.A.",
  "BCO WESTERN UNION",
  "BCO WOORI BANK DO BRASIL S.A.",
  "BCO XP S.A.",
  "BEETELLER",
  "BK IP S.A.",
  "BM PLENO S.A.",
  "BMP SCD S.A.",
  "BMP SCMEPP LTDA",
  "BMS SCD S.A.",
  "BOFA MERRILL LYNCH BM S.A.",
  "BONUSPAGO SCD S.A.",
  "BPY CCTVM S.A.",
  "BRB - BCO DE BRASILIA S.A.",
  "BRCONDOS SCD S.A.",
  "CAIXA ECONOMICA FEDERAL",
  "CAPITAL CONSIG SCD S.A.",
  "CARTOS SCD S.A.",
  "CARUANA SCFI",
  "CASA CREDITO S.A. SCM",
  "CC LAR CREDI",
  "CCM DESP TRÂNS SC E RS",
  "CCR COOPAVEL",
  "CCR DE ABELARDO LUZ",
  "CCR DE IBIAM",
  "CCR SEARA",
  "CDC SCD S.A.",
  "CELCOIN IP S.A.",
  "CIELO IP S.A.",
  "CLOUDWALK IP LTDA",
  "COBUCCIO S.A. SCFI",
  "CONTA PRONTA IP",
  "COOP COOPERFORTE LTDA.",
  "COOP CREDI&GENTE",
  "COOP CREDITAG",
  "COOP DE AGRICULTORES E AEROPORTUÁRIOS DO BRASIL",
  "COOP DE PRIMAVERA DO LESTE",
  "COOP SULCREDI AMPLEA",
  "COOPCENTRAL AILOS",
  "CORA SCFI",
  "CRED.UFES",
  "CREDIALIANÇA CCR",
  "CREDICOAMO",
  "CREDIFIT SCD S.A.",
  "CREDISAN CC",
  "CREDISIS - CENTRAL DE COOPERATIVAS DE CRÉDITO LTDA.",
  "CREDITAS SCD",
  "CREDSYSTEM SCD S.A.",
  "CRESOL CONFEDERAÇÃO",
  "DELCRED SCD S.A.",
  "DGBK CREDIT S.A. - SOCIEDADE DE CRÉDITO DIRETO.",
  "DOCK IP S.A.",
  "EBANX IP LTDA.",
  "EBURY BCO DE CÂMBIO S.A.",
  "EFÍ S.A. - IP",
  "EWALLY IP S.A.",
  "F D GOLD DTVM LTDA",
  "FIDUCIA SCMEPP LTDA",
  "FITBANK IP",
  "G5 SCD SA",
  "GAZINCRED S.A. SCFI",
  "GLOBAL SCM LTDA",
  "Goldman Sachs Do Brasil Bm S.A",
  "HBI SCD",
  "HEMERA DTVM LTDA.",
  "Hipercard Bm S.A",
  "HR DIGITAL SCD",
  "HSCM SCMEPP LTDA.",
  "ID CTVM",
  "INCO SEP S.A.",
  "InfinitePay",
  "INTRA DTVM",
  "ISSUER IP LTDA.",
  "ITAÚ UNIBANCO S.A.",
  "IUGU IP S.A.",
  "J17 - SCD S/A",
  "KIKAI SCD S.A.",
  "LISTO SCD S.A.",
  "MAG IP LTDA.",
  "MAGALUPAY",
  "MAGNUM SCD",
  "MAPS IP LTDA.",
  "MERCADO PAGO IP LTDA.",
  "MICROCASH SCMEPP LTDA.",
  "MIDWAY S.A. - SCFI",
  "MONETARIE SCD",
  "MT IP S.A.",
  "MW IP LTDA.",
  "NEON PAGAMENTOS S.A. IP",
  "Next",
  "NOVO BCO CONTINENTAL S.A. - BM",
  "Nubank",
  "NUMBRS SCD S.A.",
  "OCTA SCD S.A.",
  "OKTO IP",
  "OMNI BANCO S.A.",
  "ONEKEY PAYMENTS IP S.A.",
  "OPEA SCD",
  "OURIBANK S.A.",
  "Outro",
  "PAGARE IP S.A.",
  "PAGPRIME IP",
  "PAGSEGURO INTERNET IP S.A.",
  "PARANA BCO S.A.",
  "PARATI - CFI S.A.",
  "PAY IP S.A.",
  "PAY4FUN IP S.A.",
  "PEFISA S.A. - C.F.I.",
  "PICPAY",
  "PICPAY BANK - BANCO MÚLTIPLO S.A",
  "PINBANK IP",
  "PLANNER SOCIEDADE DE CRÉDITO DIRETO",
  "Planner Corretora De Valores S.A",
  "POLOCRED SCMEPP LTDA.",
  "PORTOSEG S.A. CFI",
  "Portocred S.A",
  "PROVER PROMOCAO DE VENDAS IP LTDA.",
  "QI SCD S.A.",
  "REAG TRUST DTVM",
  "REALIZE SCFI S.A.",
  "REVOLUT SCD S.A.",
  "SANTS SCD S.A.",
  "SEFER INVESTIMENTOS DTVM LTDA",
  "SER FINANCE SCD S.A.",
  "SERVICOOP",
  "SIMPAUL",
  "SINGULARE CTVM S.A.",
  "SISPRIME DO BRASIL - COOP",
  "SOCIAL BANK S/A",
  "SOCINAL S.A. CFI",
  "SOCRED SA - SCMEPP",
  "SRM BANK",
  "STARK BANK S.A. - IP",
  "STARK SCD S.A.",
  "STONE IP S.A.",
  "SUMUP SCD S.A.",
  "SUPERDIGITAL I.P. S.A.",
  "SUPERLÓGICA SCD S.A.",
  "TRANSFEERA IP S.A.",
  "TRINUS SCD S.A.",
  "TRIO IP LTDA.",
  "Ubs Brasil Cctvm S.A",
  "UNAVANTI SCD S/A",
  "UNICRED DO BRASIL",
  "UNIPRIME COOPCENTRAL LTDA.",
  "UP.P SEP S.A.",
  "URBANO S.A. SCFI",
  "VIA CERTA FINANCIADORA S.A. - CFI",
  "VORTX DTVM LTDA.",
  "WARREN CVMC LTDA",
  "WE PAY OUT IP LTDA.",
  "WILL FINANCEIRA S.A.CFI",
  "WOOVI IP LTDA.",
  "Z1 IP LTDA.",
  "ZEMA CFI S/A",
  "ZERO IP",
  "ZOOP MEIOS DE PAGAMENTO",
  "ÓTIMO SCD S.A."
];